import { getOwner } from '@ember/application';
import Service from '@ember/service';
import { captureException, captureMessage } from '@sentry/browser';

// A service that wraps the Sentry Javascript SDK.
// Sentry must be configured and initialized in the consuming app (eg, Dashboard).
// For more information about capturing custom errors and messages,
// see the docs: https://docs.sentry.io/error-reporting/capturing/?platform=node
export default class Sentry extends Service {
  captureException(...args) {
    if (this.shouldLog) {
      captureException(...args);
    } else {
      // eslint-disable-next-line no-console
      console.error('[SENTRY]', args[0]);
    }
  }
  captureMessage(...args) {
    if (this.shouldLog) {
      captureMessage(...args);
    } else {
      // eslint-disable-next-line no-console
      console.error('[SENTRY]', args[0]);
    }
  }
  get shouldLog() {
    return getOwner(this).resolveRegistration('config:environment').environment === 'production';
  }
}